import { render, staticRenderFns } from "./AppSideEffectsStuffNotToWorryAbout.vue?vue&type=template&id=aa86b16a&scoped=true&"
import script from "./AppSideEffectsStuffNotToWorryAbout.vue?vue&type=script&lang=js&"
export * from "./AppSideEffectsStuffNotToWorryAbout.vue?vue&type=script&lang=js&"
import style0 from "./AppSideEffectsStuffNotToWorryAbout.vue?vue&type=style&index=0&id=aa86b16a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa86b16a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
